import {ChangeDetectionStrategy, Component, ElementRef} from '@angular/core';
import {SavedCartFormDialogComponent} from "@spartacus/cart/saved-cart/components";
import {FormUtils, LaunchDialogService} from "@spartacus/storefront";
import {SavedCartFacade, SavedCartFormType} from "@spartacus/cart/saved-cart/root";
import {EventService, GlobalMessageService, RoutingService} from "@spartacus/core";
import {GonvarriSavedCartService} from "../../core/services/gonvarri-saved-cart.service";

@Component({
  selector: 'cx-saved-cart-form-dialog',
  templateUrl: './gonvarri-saved-cart-form-dialog.component.html',
  styleUrl: './gonvarri-saved-cart-form-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GonvarriSavedCartFormDialogComponent extends SavedCartFormDialogComponent {

  override savedCartService: GonvarriSavedCartService;

  constructor(
    launchDialogService: LaunchDialogService,
    el: ElementRef,
    savedCartService: GonvarriSavedCartService,
    eventService: EventService,
    routingService: RoutingService,
    globalMessageService: GlobalMessageService
  ) {
    super(launchDialogService, el, savedCartService, eventService, routingService, globalMessageService);
    this.savedCartService = savedCartService;
  }

  override saveOrEditCart(cartId: string | undefined): void {
    const cartIdString = cartId as string;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      FormUtils.deepUpdateValueAndValidity(this.form);
    } else {
      const name = this.form.get('name')?.value;
      const description = this.form.get('description')?.value || '-';

      switch (this.layoutOption) {
        case SavedCartFormType.SAVE: {
          this.savedCartService.saveCart({
            cartId: cartIdString,
            saveCartName: name,
            saveCartDescription: description,
            cloneCart: true
          });
          break;
        }
        case SavedCartFormType.EDIT: {
          this.savedCartService.editSavedCart({
            cartId: cartIdString,
            saveCartName: name,
            saveCartDescription: description,
            cloneCart: false
          });
          break;
        }
      }
    }
  }

  getId(): string {
    return 'dialogTitle';
  }

}
